import React, { useState, useEffect, useId } from "react";
import axios from "axios";
import { useForm, useFormState } from "react-hook-form";
import { IoTicketOutline } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import MyCountdown from "../parts/countdown";

export default function Form() {

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isSubmitSuccessful, isSubmitted , isSubmitting}
    } = useForm();

    const ubdCheckboxId = useId();
    const [preloader, preloaderFormStyle] = useState('hidden');
    const [promoAlert, setPromoAlertData] = useState('');
    const [promoAlertStyle, setPromoAlerStyle] = useState('');

    const [event, setEvent] = useState({});

    const clearDataPromo = async (data) => {

        var promocodeData = {
            promocode: data,
            site_name : domain,
            action: 'checkpromo'
        }
        try {
            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4077',
                promocodeData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            if (response.status === 201 || response.status === 200) {
                if(response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(FaCheck);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const onSubmit = async (data) => {

        try {

            preloaderFormStyle('flex');

            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4077',
                data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

            // Check if response is successful
            if(response.data.check !== false) {
                // Відстеження события одразу після успішної відповіді від сервера
                if (window.gtag) {
                    window.gtag('event', 'generate_lead', {
                        'form_type': 'registration',
                        'form_name': 'Registration Form',
                        'price': data.price || 6500,
                        'currency': 'UAH'
                    }, { 'transport': 'beacon' }); // beacon гарантує відправку навіть при редиректі
                }

                // Невелика затримка перед редиректом для синхронізації GA
                setTimeout(() => {
                    if (response.status === 201 || response.status === 200) {
                        window.location.href = response.data;
                    }
                }, 100);
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            preloaderFormStyle('hidden');
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if(value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    const errorStyle = "absolute top-0 right-0 text-red-800 z-10 bg-white text-sm h-full w-[80px] p-[4px] leading-none rounded-r flex items-center items-center";
    const successStyle = "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full h-full p-[4px] leading-none rounded-full flex items-center items-center";
    const domain =   window.location.protocol + '//' + window.location.host;

    //get url parameters
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") ? searchParams.get("utm_source") : '';
    const utm_medium = searchParams.get("utm_medium") ? searchParams.get("utm_medium") : '';
    const utm_campaign = searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : '';

    return (
        <div className="w-full">

            <form onSubmit={handleSubmit(onSubmit)} className="relative md:flex md:flex-wrap md:items-center md:gap-4 relative z-10 max-w-[540px]">
                <div className="w-full relative mb-[10px] md:mb-0 md:flex-[calc(50%_-_8px)]">
                    <input type="email" name="email" {...register("email", {required: true})} placeholder="Пошта"
                        className="form-input bg-transparent uppercase border-[1px]  border-black placeholder:text-black 
                        w-full py-3 px-5 h-[50px] text-xs font-medium text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none 
                        focus:bg-transparent focus:border-black"/>
                    {errors.email && <div className={errorStyle}>вкажіть email</div>}
                </div>
                <div className="w-full relative mb-[10px] md:mb-0 md:flex-[calc(50%_-_8px)]">
                    <input
                        type="text"
                        {...register("phone", {
                            required: true,
                            pattern: /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}-[0-9]{0,5}/ && /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/
                        })}
                        maxLength="17"
                        placeholder="Тел. (099) 999-99-99"
                        onChange={(event) => {
                            const {value} = event.target;
                            event.target.value = normalizeTel(value);
                        }}
                        name="phone"
                        className={"form-input h-[50px] text-xs font-medium bg-transparent uppercase border-[1px]  border-black placeholder:text-black w-full py-3 px-5 text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none focus:bg-transparent focus:border-black " + (errors.phone ? "form-control text-amber-700" : "form-control")}/>
                    {errors.phone && errors.phone.type === "required" && (
                        <div className={errorStyle}>вкажіть телефон</div>
                    )}
                    {errors.phone && errors.phone.type === "pattern" && (
                        <div className={errorStyle}>вкажіть телефон</div>
                    )}
                </div>

                <input name="event_name" {...register("event_name")} type="hidden" value="67ff65c9e9e0212822c63cf1"/>
                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="price" {...register("price")} type="hidden" value="6500"/>
                <input name="position" {...register("position")} type="hidden" value=""/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>

                <div className="w-full relative mb-[10px] md:mb-0 md:flex-[calc(50%_-_8px)]">
                    <input
                        type="text"
                        {...register("promocode")}
                        name="promocode"
                        placeholder="Промокод"
                        onBlur={(event) => {
                            const {value} = event.target;
                            clearDataPromo(value);
                        }}
                        className={"form-input h-[50px] text-xs font-medium text-xs font-medium bg-transparent uppercase form-input  border-[1px] border-black placeholder:text-black w-full py-3 px-5 text-neutral-800 focus:placeholder-neutral-800 leading-tight focus:outline-none focus:bg-transparent focus:border-black " + (errors.phone ? "form-control text-amber-700" : "form-control")}/>
                    {promoAlert ? <div className={promoAlertStyle}>{promoAlert}</div> : null}

                </div>

                <div className="mb-[14px] flex items-center gap-3 md:hidden  md:mb-0">
                    <input type="checkbox" id={ubdCheckboxId}
                        {...register("ubd")}
                        className="w-4 h-4  border-[1px] border-black cursor-pointer checked:bg-[#000] checked:border-[#000]"
                        value="ubd"
                    />
                    <label htmlFor={ubdCheckboxId} className="text-[14px] font-medium cursor-pointer select-none uppercase">Маю посвідчення УБД</label>
                </div>
                <a href="https://forms.gle/imdeufEXeuFPcybM7" target="_blank"
                    className="text-xs font-medium uppercase mb-6 block underline md:hidden">Корпоративним клієнтам</a>

                <button type="submit" className="form-button bg-[#37D3CA] h-[50px] text-xs xl:text-xl tracking-widest leading-none uppercase text-center border border-[#000]
                 w-full py-3 px-6 font-bold hover:scale-105 transition-all duration-300 ease-out md:mb-0 md:flex-[calc(50%_-_8px)]">
                    надіслати
                </button>

                {/* <div className="mb-[14px] flex items-center gap-3 hidden md:flex  md:mb-0">
                    <input type="checkbox" id={ubdCheckboxId}
                        {...register("ubd")}
                        className="w-4 h-4 appearance-none border-[1px] border-black cursor-pointer checked:bg-[#000] checked:border-[#000]"
                        value="ubd"
                    />
                    <label htmlFor={ubdCheckboxId} className="text-[14px] font-medium cursor-pointer select-none uppercase">Маю посвідчення УБД</label>
                </div> */}
                <a href="https://forms.gle/imdeufEXeuFPcybM7" target="_blank"
                    className="text-[14px] font-medium uppercase mb-6 block underline hidden md:block md:mb-0 hover:text-[#e8b500] transition-colors duration-300">Корпоративним клієнтам</a>


                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#e8b500] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/> <span>Зачекайте...</span>
                    </div>
                </div>
            </form>

        </div>

    )
}